import React, { FC } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { change, formValueSelector } from 'redux-form'
import { actions as LKModalActions } from '../../shared/LKModal'
import { OpenButton } from '../../AccountForm'
import { AppDispatch } from 'src/store/index.d'
import { accountViewBase } from 'src/store/account'

const DebitAccountAddButton: FC<{
  FormName: string
  disabled: boolean
  fetcherName: string
  chooseAccount?: boolean
  chooseClient?: boolean
  formValue?: string
}> = ({ FormName, disabled, fetcherName, chooseAccount = true, formValue = 'CCY' }) => {
  const dispatch = useDispatch<AppDispatch>()

  const ccy: string = useSelector((state) => formValueSelector(FormName)(state, formValue))

  function fetchAccountInformation(data) {
    // dispatch(
    //   fetchSFM({
    //     instanceName: fetcherName,
    //     callApi: Account.details,
    //     callApiArgs: [data],
    //   }),
    //   //@ts-ignore
    // ).then(({ Data }) => {
    //   if (Data.CCY === ccy && chooseAccount) {
    //     dispatch([
    //       change(FormName, 'DebitAccNo', Data.AccNo),
    //       change(FormName, 'DebitTitleUNI', Data.TitleUNI),
    //       change(FormName, 'DebitAccID', data.ID),
    //       change(FormName, 'DebitAccHash', data.hash),
    //       change(FormName, 'DebitAccBalance', Data.Balance),
    //     ])
    //   }
    // })

    //UPDATED API REQUEST acc_account_view_api page: base
    dispatch(
      accountViewBase({
        AccountID: data.ID,
        HashSum_AccountID_: data.hash,
      }),
    )
      .then((response) => {
        if (!accountViewBase.fulfilled.match(response)) {
          throw new Error((response.payload as any).message)
        }
        const { payload: Data } = response
        if (Data.CCY === ccy && chooseAccount) {
          //@ts-ignore
          dispatch([
            change(FormName, 'DebitAccNo', Data.AccNo),
            change(FormName, 'DebitTitleUNI', Data.TitleUNI),
            change(FormName, 'DebitAccID', data.ID),
            change(FormName, 'DebitAccHash', data.hash),
            change(FormName, 'DebitAccBalance', Data.Balance),
          ])
        }
      })
      .catch((e) => {
        dispatch(LKModalActions.openError(e.message))
      })
  }

  return (
    // @ts-ignore
    <OpenButton name="DebitAccountAdd" icon="account_add" disabled={disabled} onSuccess={fetchAccountInformation} />
  )
}

export default DebitAccountAddButton
